export const traductions = {
  PE: {
    'barrio': 'distrito',
  },
}